import Pagination from "@mui/material/Pagination";
import { ClipboardList, Boxes, Home, MapPin, PackageCheck, Truck } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey, getDateAndTime, handleDateChange } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { DateBox, FormButton, InputBox, SelectInputBox } from "../CommonComponents/InputBox";
import { ColorRing } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
const ShipmentReport = ({ menuText }) => {
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        fromDate: getDateAndTime().date,
        toDate: getDateAndTime().date,
        awbNo: '',
        pickUpRefernceNo: '',
        port: '',
        status: '',
    })

    //--Handle Clear Function--//
    const handleClear = () => {
        setFormData({
            fromDate: getDateAndTime().date,
            toDate: getDateAndTime().date,
            awbNo: '',
            pickUpRefernceNo:'',
            port: '',
            status: '',
            client: ''
        });
        filterData.SearchText = ''
        getShipmentReportData()
        setResult([]);
        inputrefs.current['txtFromDate'].focus();
    };


    //--Grid Data Fetch Function--//
    const getShipmentReportData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Report/PickupReport', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED' || data.Status === 'ERROR') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getShipmentReportData(value);
    };

    const trackingIcons = {
        "Pickup Requested": Boxes,
        Booked: ClipboardList,
        Picked: PackageCheck,
        "In Transit": Truck,
        OFD: MapPin,
        Delivered: Home
    };

    useEffect(() => {
        getShipmentReportData();
    }, [sortConfig, filterData]);

    useEffect(() => {
        inputrefs.current['txtFromDate'].focus();
        document.title = 'Shipment Report'
    }, [])

    const countNo = Math.ceil((parseInt(result?.totalRecord) / parseInt(result?.pageSize)));

    
    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText : FindTranslatedKey('Shipment Report')}</h6>
                </div>
                <div className='card-body row'>
                    <div className='row'>
                        <DateBox
                            inputrefs={inputrefs}
                            label="From Date"
                            id='txtFromDate'
                            selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtToDate']?.focus();
                                }
                            }}
                        />
                        <DateBox
                            inputrefs={inputrefs}
                            label="To Date"
                            id='txtToDate'
                            selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtAWB']?.focus();
                                }
                            }}
                        />

                        <InputBox
                            label="AWB"
                            placeholder="AWB"
                            inputrefs={inputrefs}
                            id='txtAWB'
                            value={formData.awbNo || ''}
                            onChange={(e) => setFormData({ ...formData, awbNo: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtPickUpRefernceNo']?.focus();
                                }
                            }}
                        />

                        <InputBox
                            label="PickUp Refernce No"
                            placeholder="PickUp Refernce No"
                            inputrefs={inputrefs}
                            id='txtPickUpRefernceNo'
                            value={formData.pickUpRefernceNo || ''}
                            onChange={(e) => setFormData({ ...formData, pickUpRefernceNo: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtPort']?.focus();
                                }
                            }}
                        />

                        <SelectInputBox
                            label='Port'
                            inputrefs={inputrefs}
                            id='txtPort'
                            value={formData.port || ''}
                            onChange={(e) => setFormData({ ...formData, port: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtStatus']?.focus();
                                }
                            }}
                        >
                            <option value=''>--Please Select--</option>
                            <option value='DEL'>Delhi</option>
                            <option value='BOM'>Mumbai</option>
                            <option value='DXB'>Dubai</option>
                        </SelectInputBox>

                        <SelectInputBox
                            label='Status'
                            inputrefs={inputrefs}
                            id='txtStatus'
                            value={formData.status || ''}
                            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtClient']?.focus();
                                }
                            }}
                        >
                            <option value=''>--Please Select--</option>
                            <option value='Pending'>Pending</option>
                            <option value='InTransit'>In Transit</option>
                            <option value='Delivered'>Delivered</option>
                        </SelectInputBox>
                    </div>
                    <div className='row pb-1 mt-2'>
                        <FormButton
                            id={'btnSub'}
                            Search={true}
                            save={false}
                            inputrefs={inputrefs}
                            handleSubmit={getShipmentReportData}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                handleDownloadExcel(`/api/Report/PickupReport`, formData, 'Shipment Report')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>
            <>
                <div className="card p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">

                        <div className='col-md-4'>
                            <h6 className='m-0 '>
                                <span>{`${result?.totalRecord !== undefined ? 'Total Records : ' + result?.totalRecord : 'No Record Found'}`}</span>
                            </h6>
                        </div>
                    <select className="form-select me-2" aria-label="PageSize" style={{ width: "110px" }}
                        value={filterData?.PageSize ? filterData?.PageSize : "10"} onChange={(e) => {
                            setFilterData({ ...filterData, PageSize: e.target.value })
                        }}
                    >  
                        <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
               
                        </select>
                    </div>
                    {loading ? (
                        <center>
                            <ColorRing
                                visible={true}
                                height="80"
                                width="80"
                                ariaLabel="blocks-loading"
                                wrapperStyle={{}}
                                wrapperClass="blocks-wrapper"
                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                            />
                        </center>
                    ) :(
                    result?.data?.map((item) => {
                        const step =
                            item.trackingMetaData?.[0]?.currentStepIndex
                                ? Number(item.trackingMetaData[0].currentStepIndex) - 1
                                : 0;
                        return (
                            <div key={item.awbNo} className="card shadow-sm border-0 mb-3">

                                {/* ───────── TOP SECTION ───────── */}
                                <div className="row align-items-center">

                                    {/* Left Section */}
                                    <div className="col-md-4 mb-2 px-4 mt-2 mb-md-0">
                                        <h6 className="fw-bold mb-1 small">
                                            AWB No -
                                            <span
                                                className="text-info small ms-1"
                                                style={{ cursor: "pointer", textDecoration: "underline" }}
                                                onClick={() => navigate(`/Tracking?awbNumber=${item.awbNo}`)}
                                            >
                                                {item.awbNo}
                                            </span>
                                        </h6>

                                        <small className="text-muted fw-semibold d-block">
                                            Booked: {item.bookingDate} | Created: {item.createdDate} by {item.createdBy}
                                        </small>

                                        <span className="badge bg-success">
                                            {item.bookingBranch} → {item.toBranch}
                                        </span>
                                    </div>

                                    {/* Center Tracking */}
                          {/*          <div className="col-md-4 mb-2 mt-2 mb-md-0">*/}

                          {/*              <div className="position-relative" style={{ width: "100%" }}>*/}

                          {/*                  */}{/* Base Line */}
                          {/*                  <div*/}
                          {/*                      className="position-absolute"*/}
                          {/*                      style={{*/}
                          {/*                          top: 18,*/}
                          {/*                          height: 3,*/}
                          {/*                          backgroundColor: "#dee2e6",*/}
                          {/*                          zIndex: 1,*/}
                          {/*                          left: 18,*/}
                          {/*                          right: 18*/}
                          {/*                      }}*/}
                          {/*                  />*/}

                          {/*                  */}{/* Progress Line */}
                          {/*                  <div*/}
                          {/*                      className="position-absolute"*/}
                          {/*                      style={{*/}
                          {/*                          top: 18,*/}
                          {/*                          height: 3,*/}
                          {/*                          left: 18,*/}
                          {/*                          width: `${(step / (item?.trackingData?.length - 1)) * 90}%`,*/}
                          {/*                          backgroundColor: "#198754",*/}
                          {/*                          zIndex: 2,*/}
                          {/*                          transition: "width 0.4s ease"*/}
                          {/*                      }}*/}
                          {/*                  />*/}

                          {/*                  */}{/* Steps */}
                          {/*                  <div*/}
                          {/*                      className="d-flex mt-1 justify-content-between position-relative"*/}
                          {/*                      style={{ zIndex: 3 }}*/}
                          {/*                  >*/}
                          {/*                      {item?.trackingData?.map((t, i) => {*/}

                          {/*                          const Icon = trackingIcons?.[t.label];*/}

                          {/*                          return (*/}
                          {/*                              <div key={t.label} className="text-center">*/}

                          {/*                                  <div*/}
                          {/*                                      className={`rounded-circle d-flex align-items-center justify-content-center mx-auto*/}
                          {/*${t.isCompleted*/}
                          {/*                                              ? "bg-success text-white"*/}
                          {/*                                              : t.isActive*/}
                          {/*                                                  ? "bg-primary text-white"*/}
                          {/*                                                  : "bg-secondary text-white"*/}
                          {/*                                          }`}*/}
                          {/*                                      style={{ width: 32, height: 32 }}*/}
                          {/*                                  >*/}
                          {/*                                      {Icon && <Icon size={16} />}*/}
                          {/*                                  </div>*/}

                          {/*                                  <div className="mt-1 small fw-semibold text-black">*/}
                          {/*                                      {t.label}*/}
                          {/*                                  </div>*/}

                          {/*                              </div>*/}
                          {/*                          );*/}
                          {/*                      })}*/}
                          {/*                  </div>*/}

                          {/*              </div>*/}
                          {/*          </div>*/}

                                    {/* Right Section */}
                                    <div className="col-md-4 row gap-2 align-items-end justify-content-end">

                                        {/*<button*/}
                                        {/*    type="button"*/}
                                        {/*    className="btn col-md-2 btn-danger btn-sm p-1"*/}
                                        {/*    style={{ width: "32px", height: "32px", padding: "0" }}*/}
                                        {/*>*/}
                                        {/*    <Pencil size={16} />*/}
                                        {/*</button>*/}
                                      
                                    </div>

                                </div>

                                {/* ───────── BOTTOM SECTION ───────── */}
                                <div className="card-body pt-2">

                                    <div className="row">

                                        {/* Shipment Info */}
                                        <div className="col-md-3 px-2">

                                            <p className="mb-0 small">
                                                <strong>Client :</strong> {item.client}
                                            </p>

                                            <p className="mb-0 small">
                                                <strong>Ref No :</strong> {item.referenceNo}
                                            </p>

                                            <p className="mb-0 small">
                                                <strong>Status :</strong>
                                                <span className="badge bg-success ms-2">
                                                    {item.pktStatus}
                                                </span>
                                            </p>

                                            {/*<p className="mb-0 small">*/}
                                            {/*    <strong>Label Status :</strong>*/}
                                            {/*    <span className="badge bg-warning text-dark ms-2">*/}
                                            {/*        {item.labelStatus || "Not Generated"}*/}
                                            {/*    </span>*/}
                                            {/*</p>*/}

                                            <p className="mb-0 small">
                                                <strong>Packet Type :</strong> {item.packetType || "-"}
                                            </p>

                                        </div>

                                        {/* Consignor */}
                                        <div className="col-md-3 p-3">

                                            <h6 className="fw-bold mb-1 text-danger">Consignor</h6>

                                            <p className="mb-0 small fw-semibold">{item.consignor}</p>

                                            <small className="d-block">{item.consignorPhoneNo}</small>

                                            <small className="d-block">{item.consignorEmailID}</small>

                                            <small>
                                                {item.consignorAddress1} {item.consignorAddress2 || ""} {item.consignorAddress3 || ""}
                                            </small>

                                            <small className="d-block">
                                                {item.consignorCity} {item.consignorCountry}
                                            </small>

                                        </div>

                                        {/* Consignee */}
                                        <div className="col-md-3 p-3">

                                            <h6 className="fw-bold mb-1 text-success">Consignee</h6>

                                            <p className="mb-0 small fw-semibold">{item.consignee}</p>

                                            <small className="d-block">{item.consigneePhoneNo}</small>

                                            <small className="d-block">{item.consigneeEmailID}</small>

                                            <small>
                                                {item.consigneeAddress1} {item.consigneeAddress2 || ""} {item.consigneeAddress3 || ""}
                                            </small>

                                            <small className="d-block">
                                                {item.consigneeCity} {item.consigneeCountry}
                                            </small>

                                        </div>

                                        {/* Package Details */}
                                        <div className="col-md-3 px-2">

                                            <h6 className="fw-bold mb-1 text-warning">
                                                Package Details
                                            </h6>

                                            <p className="mb-0 small">
                                                <strong>Actual Weight :</strong> {item.actualWeight || "-"} {item.weightUnit}
                                            </p>

                                            <p className="mb-0 small">
                                                <strong>Volumetric Weight :</strong> {item.volumetricWeight || "-"} {item.weightUnit}
                                            </p>

                                            <p className="mb-0 small">
                                                <strong>Charge Weight :</strong> {item.chargedWeight || "-"} {item.weightUnit}
                                            </p>

                                            <p className="mb-0 small">
                                                <strong>Total Packet :</strong> {item.totalPCS || "-"}
                                            </p>

                                            <p className="mb-0 small">
                                                <strong>Invoice Value :</strong> {item.invoiceCurrencyCode} {item.invoiceValue || "-"}
                                            </p>

                                           

                                            <p className="mb-0 small">
                                                <strong>Vendor :</strong> {item.vendor || "-"}
                                            </p>

                                            <p className="mb-0 small">
                                                <strong>Service Type :</strong> {item.serviceType || "-"}
                                            </p>

                                           
                                            <p className="mb-0 small">
                                                <strong>Description :</strong> {item.description || "-"}
                                            </p>
                                            <p className="mb-0 small">
                                                <strong>Freight :</strong> {item.freight || "-"}
                                            </p>
                                            <p className="mb-0 small">
                                                <strong>Fuel Amount :</strong> {item.fuelAmount || "-"}
                                            </p>
                                            <p className="mb-0 small">
                                                <strong>Total Amount :</strong> {item.totalAmount || "-"}
                                            </p>

                                        </div>

                                    </div>
                                </div>

                            </div>
                        );
                    })
                    )}
                    {countNo >= 1 && (
                        <Pagination className="mt-3"
                            count={countNo}
                            page={currentPageNo}
                            onChange={handleChange1}
                            variant="outlined"
                            shape="rounded"
                        />
                    )}
                   
                </div>
            </>
        </>
    )
}

export default ShipmentReport;